import React from 'react';
import { cn } from "@/lib/utils";

interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: Array<{ value: T; label: string }>;
  'aria-label'?: string;
}

/** Pílula de seleção — Figma node 124:13047 ("Tab" / "Tab Item"). */
export const SegmentedControl = <T extends string>({ value, onChange, options, 'aria-label': ariaLabel }: SegmentedControlProps<T>) => {
  return (
    <div
      className="inline-flex items-center rounded-full border border-neutral-300 bg-white p-1"
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-full px-2 py-1 text-xs font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring",
            value === option.value
              ? "bg-primary-50 text-primary-700 shadow-[0px_3px_5px_rgba(0,0,0,0.05)]"
              : "text-neutral-600 hover:text-neutral-900",
          )}
          role="radio"
          aria-checked={value === option.value}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
